import Rx from 'rxjs/Rx';

export default class PollerService {
    constructor($http, $timeout) {
        this.$http = $http;
        this.$timeout = $timeout;
        this._timeouts = {};
    }

    poll(api, params, headers) {
        return this.$http({
            method: 'GET',
            url: api,
            params: params
        }, headers).then(
            (response) => response.data,
            (response) => {
                return {};
            }
        );
    }

    startPolling(api, params={}, headers={}, tick=30000) {
        /**
         * Beware, this long-polling service exclusively makes GET requests.
         */
        this._timeouts[api] = {};
        return Rx.Observable.create(observer => {
            var callback = (data) => {
                observer.next(data);
            };
            var startAgain = () => {
                if (!this._timeouts.hasOwnProperty(api)) { return; }
                this._timeouts[api] = this.$timeout(() => {
                    this.poll(api, params, headers).then(callback)['finally'](startAgain);
                }, tick);
            };
            this.poll(api, params, headers).then(callback)['finally'](startAgain);
        });
    }

    stopPolling(api) {
        if (this._timeouts.hasOwnProperty(api)) {
            this.$timeout.cancel(this._timeouts[api]);
            delete this._timeouts[api];
        }
    }
}

PollerService.$inject = ['$http', '$timeout'];


// WEBPACK FOOTER //
// ./src/app/services/poller.service.js